$(document).ready(function(){

  $('.manage_cookies').click(function(){
    $('.s-cookies .statement').hide();
    $('.s-cookies .manage').show();
  });

});
